import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SceneTransitionProvider } from "./components/SceneTransition";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AggregatorPage from "./pages/AggregatorPage";
import PlatformPage from "./pages/PlatformPage";
import PaymentsPage from "./pages/PaymentsPage";
import CryptoPage from "./pages/CryptoPage";
import CareersPage from "./pages/CareersPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import AMLPolicyPage from "./pages/AMLPolicyPage";
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./pages/AdminLayout";
import AdminInbox from "./pages/AdminInbox";
import AdminStats from "./pages/AdminStats";
import { PageTracker } from "./components/PageTracker";
import { TelegramButton } from "./components/TelegramButton";


function App() {
  return (
    <LanguageProvider>
      <div className="App grain min-h-screen bg-[#080808]" data-testid="app-container">
        <BrowserRouter>
          <SceneTransitionProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/services/aggregator" element={<AggregatorPage />} />
            <Route path="/services/platform" element={<PlatformPage />} />
            <Route path="/services/payments" element={<PaymentsPage />} />
            <Route path="/services/crypto" element={<CryptoPage />} />
            <Route path="/blog" element={<Navigate to="/" replace />} />
            <Route path="/blog/*" element={<Navigate to="/" replace />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
            <Route path="/aml-policy" element={<AMLPolicyPage />} />
            
            {/* Admin Routes */}
            <Route path="/website/admin" element={<AdminLogin />} />
            <Route path="/website/admin" element={<AdminLayout />}>
              <Route path="inbox" element={<AdminInbox />} />
              <Route path="stats" element={<AdminStats />} />
              <Route path="*" element={<Navigate to="/website/admin/inbox" replace />} />
            </Route>
            <Route path="/admin" element={<Navigate to="/" replace />} />
            <Route path="/admin/*" element={<Navigate to="/" replace />} />
          </Routes>
          <TelegramButton />
          <PageTracker />
          </SceneTransitionProvider>
        </BrowserRouter>
        <Toaster 
          position="top-right"
          toastOptions={{
            style: {
              background: '#121212',
              border: '1px solid rgba(200,170,115,0.3)',
              color: '#F4F0E8',
              fontFamily: 'Manrope, sans-serif'
            }
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
